(() => {
  const root = document.querySelector('[data-osea-chat]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const toggle = root.querySelector('[data-osea-chat-toggle]');
  const panel = root.querySelector('[data-osea-chat-panel]');
  const closeButton = root.querySelector('[data-osea-chat-close]');
  if (!toggle || !panel || !closeButton) return;

  let hideTimer;

  const openChat = () => {
    window.clearTimeout(hideTimer);
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      panel.classList.add('is-open');
      const target = panel.querySelector('textarea, input');
      if (target && window.matchMedia('(min-width: 761px)').matches) target.focus({ preventScroll: true });
    });
  };

  const closeChat = () => {
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    hideTimer = window.setTimeout(() => { panel.hidden = true; }, 210);
    toggle.focus({ preventScroll: true });
  };

  toggle.addEventListener('click', () => {
    if (panel.hidden) openChat();
    else closeChat();
  });
  closeButton.addEventListener('click', closeChat);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) closeChat();
  });

  document.addEventListener('pointerdown', (event) => {
    if (!panel.hidden && !root.contains(event.target)) closeChat();
  });

  if (root.querySelector('[data-osea-chat-success], [data-osea-chat-errors]')) openChat();
})();